<template>
  <div>
    <h1>Project Preview</h1>
    <div id="app">
      <iframe
        :src="projectToBeDisplayed.link"
        :title="`${projectToBeDisplayed.name} embedded link`"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "projectInfo",
  data() {
    return {};
  },
  props: {
    projectToBeDisplayed: Object
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@300;400;700&display=swap");

h1 {
  width: 50%;
  margin: 10px auto;
}
#app,
#app iframe {
  height: 90vh;
  width: 100%;
  border: 1px solid rebeccapurple;
  box-sizing: border-box;
}

* {
  box-sizing: border-box;
  font-family: "Source Sans Pro", sans-serif;
  margin: 0;
  padding: 0;
}

body {
  align-items: center;
  background: #030403;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectsInfo.vue